module.exports = __webpack_public_path__ + "static/media/1.a11407fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16101/1.jpg
// module id = 534
// module chunks = 0